(() => {
  const guide = document.querySelector('[data-mix-guide]');
  if (!guide) return;
  const mode = guide.dataset.configMode || 'candy';
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const setOpen = (root, open) => {
    if (!root) return;
    root.hidden = !open;
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
    if (open) setTimeout(() => q('.mix-modal__dialog', root)?.focus(), 30);
  };
  const advisor = q('[data-mix-advisor]');
  const missing = q('[data-missing-candy]');
  let lastFocus = null;

  document.addEventListener('click', event => {
    if (event.target.closest('[data-mix-advisor-open]')) { lastFocus = event.target; setOpen(advisor, true); }
    if (event.target.closest('[data-mix-advisor-close]')) { setOpen(advisor, false); lastFocus?.focus?.(); }
    if (event.target.closest('[data-missing-candy-open]')) { lastFocus = event.target; setOpen(missing, true); }
    if (event.target.closest('[data-missing-candy-close]')) { setOpen(missing, false); lastFocus?.focus?.(); }
  });

  const waitForFilters = async () => {
    for (let attempt = 0; attempt < 30; attempt += 1) {
      const buttons = qa('#filter-buttons .filter-btn');
      if (buttons.length) return buttons;
      await new Promise(resolve => setTimeout(resolve, 180));
    }
    return [];
  };
  const moveToIngredients = () => {
    const current = qa('.config-step').find(step => getComputedStyle(step).display !== 'none');
    (current || q('.candy-configurator'))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const applyPreferences = async (surprise = false) => {
    const status = q('[data-mix-advisor-status]');
    if (status) status.textContent = 'Wir stellen deine Auswahl zusammen …';
    setOpen(advisor, false);
    moveToIngredients();
    const randomTrigger = q('#random-candy-trigger');
    if (randomTrigger) {
      randomTrigger.click();
      await new Promise(resolve => setTimeout(resolve, 120));
    }
    if (surprise) {
      const surpriseButton = q('#random-filter-surprise');
      if (surpriseButton) surpriseButton.click();
      return;
    }
    const wanted = qa('[data-mix-preference]:checked', advisor).map(input => input.value.toLowerCase());
    const filterButtons = qa('#random-filter-options .filter-btn').length
      ? qa('#random-filter-options .filter-btn')
      : await waitForFilters();
    let matches = 0;
    filterButtons.forEach(button => {
      const key = `${button.dataset.tag || ''} ${button.textContent || ''}`.toLowerCase();
      if (wanted.some(term => key.includes(term))) { button.click(); matches += 1; }
    });
    const proceed = q('#random-filter-proceed');
    if (proceed && matches) proceed.click();
    else if (randomTrigger && !q('#random-filter-modal:not([hidden])')) randomTrigger.click();
    if (status) status.textContent = matches ? `${matches} passende Filter übernommen.` : 'Keine exakte Filterbezeichnung gefunden – der Mix bleibt frei bearbeitbar.';
  };
  q('[data-mix-advisor-apply]')?.addEventListener('click', () => void applyPreferences(false));
  q('[data-mix-surprise]')?.addEventListener('click', () => void applyPreferences(true));

  const form = q('[data-missing-candy-form]');
  form?.addEventListener('submit', async event => {
    event.preventDefault();
    const status = q('[data-missing-candy-status]', form);
    const submit = q('button[type="submit"]', form);
    const data = new FormData(form);
    if (data.get('website')) return;
    submit.disabled = true;
    if (status) status.textContent = 'Wunsch wird gespeichert …';
    try {
      const response = await fetch(guide.dataset.requestEndpoint, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          request: String(data.get('request') || '').trim(),
          email: String(data.get('email') || '').trim(),
          mode,
          page: location.href
        })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.error || 'Der Wunsch konnte gerade nicht gespeichert werden.');
      form.reset();
      if (status) status.textContent = 'Danke! Dein Wunsch ist jetzt auf unserer Einkaufsliste. 🦈';
    } catch (error) {
      if (status) {
        const message = error instanceof Error ? error.message : '';
        if (message && !/fetch|network|failed/i.test(message)) status.textContent = message;
        else status.innerHTML = 'Das Formular hatte gerade Schluckauf. Schreib uns bitte an <a href="mailto:info@snackshark.de">info@snackshark.de</a>.';
      }
    } finally { submit.disabled = false; }
  });

  const legalText = q('.terms-acceptance-text');
  if (legalText) legalText.innerHTML = 'Mir ist bekannt, dass diese Mischung nach meiner individuellen Auswahl angefertigt wird und für solche Waren nach § 312g Abs. 2 Nr. 1 BGB grundsätzlich kein Widerrufsrecht besteht. <a class="configurator-legal-link" href="/policies/refund-policy" target="_blank" rel="noopener">Hinweise zum Widerruf öffnen</a>.';
  const engine = q('.candy-configurator');
  if (engine && !q('.configurator-engine-note')) {
    const note = document.createElement('p');
    note.className = 'configurator-engine-note';
    note.textContent = mode === 'muesli' ? 'Deine Auswahl wird als ein individueller Müsli-Auftrag an unser Packteam übergeben.' : 'Jede ausgewählte Sorte landet eindeutig auf dem Fertigungslabel für unser Hygieneteam.';
    engine.after(note);
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (advisor && !advisor.hidden) setOpen(advisor, false);
    if (missing && !missing.hidden) setOpen(missing, false);
  });
})();
